import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import SvgMailboxFull from '../../svg/mailbox-full';
import SvgCashBlank from '../../svg/cash-blank';
import SvgUser from '../../svg/user';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

class ConfirmInvoiceModal extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired,
    amount: PropTypes.string,
    invoice: PropTypes.object,
    customer: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };
  }

  confirm = () => {
    this.props.callback(true);
  }

  reject = () => {
    this.props.callback(false);
  }

  messageMailInfo (invoice) {
    return (
      <div>
        <div className='confirm-preregister-modal-block'>
          <strong>{proxyCounterpart('CONFIRM_INVOICE_MODAL_MAIL_TO')}</strong>
        </div>
        <div className='confirm-preregister-modal-block'>
          {invoice.customerEntity.name}
        </div>
        <div className='confirm-preregister-modal-block'>
          {invoice.customerEntity.address.co}
        </div>
        <div className='confirm-preregister-modal-block'>
          {invoice.customerEntity.address.street}
        </div>
        <div className='confirm-preregister-modal-block'>
          {invoice.customerEntity.address.zip}&nbsp;
          {invoice.customerEntity.address.city}&nbsp;
          {invoice.customerEntity.address.country}
        </div>
      </div>
    );
  }

  messageSendInfo () {
    const invoice = this.props.invoice;
    if (invoice) {
      // Billing emailinvoiceMessageType
      if (invoice.messageType === 'email' && invoice.sendToEmail) {
        return `${proxyCounterpart('CONFIRM_INVOICE_MODAL_EMAIL_TO')}
          ${invoice.sendToEmail}`;
      }

      // // Secondary billing email
      if (invoice.messageType === 'email' && invoice.sendToEmailSecondary) {
        return `${proxyCounterpart('CONFIRM_INVOICE_MODAL_EMAIL_TO')}
          ${invoice.sendToEmailSecondary}`;
      }

      // Send To SMS
      if (invoice.messageType === 'sms' && invoice.companyPhone) {
        return `${proxyCounterpart('CONFIRM_INVOICE_MODAL_SMS_TO')}
          ${invoice.companyPhone}`;
      }

      // Send To E-invoice
      if (invoice.messageType === 'e-invoice' && invoice.einvoiceAddress) {
        return `${proxyCounterpart('CONFIRM_INVOICE_MODAL_E_INVOICE_TO')}
          ${invoice.einvoiceAddress}`;
      }

      // Send By Mail
      if (invoice.messageType === 'mail') {
        return this.messageMailInfo(invoice);
      }
    }
  }

  render = () => {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.reject}>
        <div className='modal-content confirm-preregister-modal'>
          <button className='close' onClick={this.reject}></button>
          <div>
            <h2 className='confirm-preregister-modal-title'>
              <Translate content='CONFIRM_INVOICE_MODAL_TITLE'/>
            </h2>
            <p className='confirm-preregister-modal-text'>
              <Translate content='CONFIRM_INVOICE_MODAL_TEXT'/>
            </p>
            <ul className='confirm-preregister-modal-infolist'>
              <li>
                <div className='infolist-icon'>
                  <SvgUser
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />
                </div>
                {this.props.customer.name}
              </li>
              <li>
                <div className='infolist-icon' >
                  <span className='cash-blank-text'>{this.props.invoice.currencyName}</span>
                  <SvgCashBlank
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />

                </div>
                {this.props.amount} <span className='infolist-lowercase'>
                  <Translate content='EXCL_VAT'/>
                </span>
              </li>
              <li>
                <div className='infolist-icon'>
                  <SvgMailboxFull
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />
                </div>
                {this.messageSendInfo()}
              </li>
            </ul>
          </div>
          <div className="confirm-preregister-modal-btn-wrapper">
            <button className="btn" onClick={this.confirm}>
              <Translate content='CONFIRM_INVOICE_MODAL_SUBMIT'/>
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConfirmInvoiceModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/confirm-invoice-modal/confirm-invoice-modal.js
 **/